import React from "react";
import { FieldArray } from "react-final-form-arrays";
import { validator } from "../validation";
import { FaTrash } from "react-icons/fa";
import SOCAdapter from "../SOCInput";
import "./styles.scss";

export const SocPicker = (props) => {
  let {
    schemaProps: { machine_name, validate, list_options },
    formApi: { mutators },
    formApi,
  } = props;

  const total =
    formApi &&
    formApi.getState() &&
    formApi.getState().values &&
    formApi.getState().values[`${machine_name}`]
      ? formApi.getState().values[`${machine_name}`].length
      : 0;
  const addItem = (item) => {
    if (item) {
      let itemObj = {};
      if (list_options.properties) {
        itemObj[`${list_options.properties.id}`] = item.id || "";
        itemObj[`${list_options.properties.description}`] =
          item.description || "";
        itemObj[`${list_options.properties.sort}`] =
          total.toString().padStart(3, "000") || "";
      } else {
        itemObj = { ...item };
      }
      if (total < list_options.max) {
        mutators.push(machine_name, itemObj);
      }
    }
  };

  const itemContainerStyle = {
    paddingLeft: "0px",
    marginTop: "10px",
  };
  const itemStyle = {
    listStyle: "none",
    padding: "10px 20px",
    margin: "0px",
    border: "1px dashed rgb(174, 176, 181)",
    backgroundColor: "rgb(255, 255, 255)",
    maxWidth: "30rem",
    position: "relative",
  };
  const itemRemoveStyle = {
    float: "right",
    color: "#025ea2",
    cursor: "pointer",
    position: "absolute",
    right: "10px",
    top: "10px",
  };
  return (
    <div className="socPicker">
      <SOCAdapter className={"testing"} {...props} addItem={addItem} />
      <FieldArray
        name={machine_name}
        validate={(values, allValues) =>
          validate ? validator(validate, allValues, null)(values) : undefined
        }
      >
        {({ fields }) => (
          <ul style={itemContainerStyle}>
            {fields &&
              fields.value &&
              fields.value.map((value, index) => (
                <li key={index} style={itemStyle} name={machine_name}>
                  {value[`${list_options.properties.id}`]} --{" "}
                  {value[`${list_options.properties.description}`]}{" "}
                  <FaTrash
                    style={itemRemoveStyle}
                    onClick={() => fields.remove(index)}
                  />
                </li>
              ))}
          </ul>
        )}
      </FieldArray>
    </div>
  );
};
